import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

export default function TopBar({ onToggleDarkMode, isDark, onOpenSettings, onBumpAll }) {
  const [menuOpen, setMenuOpen] = useState(false);           // Controls visibility of the dropdown menu
  const [isFullscreen, setIsFullscreen] = useState(false);   // Tracks fullscreen state
  const menuRef = useRef(null);                               // Reference to the dropdown menu
  const navigate = useNavigate();                             // Router hook for navigation

  /**
   * Toggle fullscreen mode.
   * - Enters fullscreen if not already in it.
   * - Exits fullscreen if already active.
   */
  const handleToggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const [showConfirm, setShowConfirm] = useState(false);  // Confirmation modal for "Bump All"


  /**
   * Handles click outside the dropdown to close it.
   * Adds listener only when menu is open.
   */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="relative flex items-center justify-between px-6 h-12 bg-white dark:bg-gray-800 border-b dark:border-gray-700 shadow-sm">

      {/* Left */}
      <div className="flex items-center gap-2 text-xl text-blue-900 dark:text-blue-300 font-bold">
        Queue Screen
      </div>

      {/* Right: Control Buttons (Dark mode, Fullscreen, Settings menu) */}
      <div className="relative flex items-center gap-4" ref={menuRef}>

        {/* Dark Mode Toggle */}
        <button
          onClick={onToggleDarkMode}
          className="relative w-12 h-6 bg-gray-300 dark:bg-gray-600 rounded-full flex items-center px-1 transition-colors duration-300">
          <div className={`w-5 h-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${isDark ? 'translate-x-6' : 'translate-x-0'}`} />
          {/* Emoji inside toggle */}
          <span className="absolute left-1 text-xs">
            <Icon icon={isDark ? 'fluent-emoji:crescent-moon' : 'fluent-emoji:sun'} className="h-4 w-4" aria-hidden="true" />
          </span>
        </button>

        {/* Fullscreen Toggle */}
        <button
          onClick={handleToggleFullscreen}
          className="text-blue-900 dark:text-blue-300 focus:outline-none mt-1.5"
          title="Toggle Fullscreen">
          <span className="material-icons-outlined"> {isFullscreen ? 'close_fullscreen' : 'open_in_full'} </span>
        </button>
      </div>

      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-80">
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">Confirm Action</h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">Are you sure you want to bump all tickets?</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-gray-100 rounded hover:bg-gray-400 dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onBumpAll();            // Call bump all action
                  setShowConfirm(false);  // Close modal
                }}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}




    </header>
  );
}
